import React from "react";
import AppContainer from "../../components/AppContainer/AppContainer";
import { Carousel } from "antd";
import FormSectionContainer from "../../components/FormSectionContainer/FormSectionContainer";
import LocalAttendeesView from "../../features/MICEreport/LocalAttendeesView";
import MiceReportFormContext from "../../features/MICEreport/context-form";
const sections = [
  {
    index: 1,
    title: "Event Information",
    headerColor: "RGB(135, 175, 221)",
    children: <LocalAttendeesView />,
  },
];

const MICEreportFormPage = () => {
  return (
    <AppContainer title="MICE - CUS REPORT">
      <MiceReportFormContext>
        <Carousel>
          {sections.map((props, index) => (
            <FormSectionContainer key={index} {...props} />
          ))}
        </Carousel>
      </MiceReportFormContext>
    </AppContainer>
  );
};

export default MICEreportFormPage;
